import EmailPreferences from "../components/EmailPreferences";
import { useT } from "../i18n";

/** Página Alertas para usuarios de organización: solo las preferencias de email.
 *  Las suscripciones de alerta ("Mis alertas") y el historial de envíos se
 *  retiraron — un usuario de cliente solo gestiona en qué emails quiere estar. */
export default function AlertsPage() {
  const t = useT();

  return (
    <div className="page" style={{ color:"var(--clr-text)", fontVariantNumeric:"tabular-nums" }}>
      <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
        <h1 style={{ margin:0, fontSize:"1.4rem", fontWeight:700, letterSpacing:"-0.02em" }}>{t("alerts.title")}</h1>
      </div>

      <div style={{ background:"var(--clr-surface)", border:"1px solid var(--clr-border)", borderRadius:18, backdropFilter:"var(--clr-blur)", WebkitBackdropFilter:"var(--clr-blur)", boxShadow:"var(--clr-shadow-sm)", padding:"1.25rem" }}>
        <EmailPreferences />
      </div>
    </div>
  );
}
